// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"excel-mappings-container__visuallyhidden--gDUCZ","focusable":"excel-mappings-container__focusable--cO0lv","container":"excel-mappings-container__container--GRyAs"};